var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-back"},[_c('div',{staticStyle:{"height":"1px"}}),_c('el-progress',{attrs:{"percentage":this.answerPercent,"stroke-width":4,"show-text":false}}),_c('div',{staticStyle:{"height":"calc(100% - 5px)"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }